// extracted by mini-css-extract-plugin
export default {"root":"Tooltip_root__JSWpx","trigger":"Tooltip_trigger__GnMFC"};